const initialState = {
    name: null,
    email: null,
    photoUrl: null
};

const userDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER_DETAILS':
            return {
                ...state,
                name: action.payload.name,
                email: action.payload.email,
                photoUrl: action.payload.photoUrl 
            };
        default:
            return state;
    }
};

export default userDetailsReducer;